import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/layout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login', //登录
      component: () => import('@/views/admin/login')
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      name: 'Dashboard', //数据概览
      children: [
        {
          path: 'dashboard',
          name: 'DashboardIndex',
          component: () => import('@/views/dashboard/index')
        }
      ]
    },
    {
      path: '/develop',
      component: Layout,
      name: 'Develop', //开发者相关
      children: [
        {
          path: 'device',
          redirect: '/develop/device',
          name: 'DevelopDevice', // 设备管理
          component: () => import('@/views/develop/device/base'),
          children: [
            {
              path: '',
              name: 'DevelopDeviceIndex',
              component: () => import('@/views/develop/device/index'),
            },
            {
              path: 'detail/:id',
              name: 'DevelopDeviceDetail',
              component: () => import('@/views/develop/device/detail'),
            },
            {
              path: 'detail/system/:id',
              name: 'systemparameter',
              component: () => import('@/views/develop/device/system/parameter'),
            }
          ]
        },
        {
          path: 'app',
          redirect: '/develop/app',
          name: 'DevelopApp', // 个人应用
          component: () => import('@/views/develop/application/base'),
          children: [
            {
              path: '',
              name: 'DevelopAppIndex',
              component: () => import('@/views/develop/application/index'),
            },
            {
              path: 'detail/:id',
              name: 'DevelopAppDetail',
              component: () => import('@/views/develop/application/detail'),
            }
          ]
        },
        {
          path: 'appstore',
          redirect: '/develop/appstore',
          name: 'DevelopAppstore', // 应用商店
          component: () => import('@/views/develop/appstore/base'),
          children: [
            {
              path: '',
              name: 'DevelopAppstoreIndex',
              component: () => import('@/views/develop/appstore/index'),
            },
            {
              path: 'detail/:id',
              name: 'DevelopAppstoreDetail',
              component: () => import('@/views/develop/appstore/detail'),
            }
          ]
        }
      ]
    },
    {
      path: '/stock',
      component: Layout,
      redirect: '/stock/index',
      name: 'Stock', //库存管理
      children: [
        {
          path: 'index',
          name: 'StockIndex',
          component: () => import('@/views/stock/index')
        },
        {
          path: 'import',
          name: 'StockImport',
          component: () => import('@/views/stock/import')
        },
        {
          path: 'detail/:id',
          name: 'StockDetail',
          component: () => import('@/views/stock/detail')
        },
        {
          path: 'imei',
          name: 'StockImei',
          component: () => import('@/views/stock/imei')
        },
        {
          path: 'export',
          name: 'StockExport',
          component: () => import('@/views/stock/export')
        },
        {
          path: 'set',
          name: 'StockSet',
          component: () => import('@/views/stock/set')
        }

      ]
    },
    {
      path: '/log',
      component: Layout,
      redirect: '/log/report',
      name: 'Log', //日志管理
      children: [
        {
          path: 'report',
          name: 'LogReport',
          component: () => import('@/views/log/report')
        },
        {
          path: 'operate',
          name: 'LogOperate',
          component: () => import('@/views/log/operate')
        },
        {
          path: 'login',
          name: 'LogLogin',
          component: () => import('@/views/log/login')
        },
      ]
    },
    {
      path: '/user',
      component: Layout,
      redirect: '/user/index',
      name: 'User', //用户管理
      children: [
        {
          path: 'index',
          name: 'UserIndex',
          component: () => import('@/views/user/index')
        },
        {
          path: 'detail/:id',
          name: 'UserDetail',
          component: () => import('@/views/user/detail')
        },
        {
          path: 'visual',
          name: 'VisualIndex',
          component: () => import('@/views/user/visual')
        },
        {
          path: 'block',
          name: 'BlockIndex',
          component: () => import('@/views/user/block')
        },
        {
          path: 'log',
          name: 'LogIndex',
          component: () => import('@/views/user/log')
        },
      ]
    },
    {
      path: '/visual',
      component: Layout,
      redirect: '/visual/type',
      name: 'Visual',
      children: [
        {
          path: 'vtype',
          name: 'VtypeIndex',
          component: () => import('@/views/visual/type')
        },
        {
          path: 'page',
          name: 'PageIndex',
          component: () => import('@/views/visual/page')
        },
      ]
    },
    {
      path: '/block',
      component: Layout,
      redirect: '/block/page',
      name: 'Block',
      children: [
        {
          path: 'page',
          name: 'BlockPage',
          component: () => import('@/views/block/page')
        },
        {
          path: 'map',
          name: 'BlockMap',
          component: () => import('@/views/block/map')
        },
        {
          path: 'log',
          name: 'BlockLog',
          component: () => import('@/views/block/log/log')
        },
        {
          path: 'contract',
          name: 'BlockContract',
          component: () => import('@/views/block/contract')
        },
      ]
    },
    {
      path: '/ams',
      component: Layout,
      redirect: '/ams/index',
      name: 'Ams', //AMS管理
      children: [
        {
          path: 'index',
          name: 'AmsIndex',
          component: () => import('@/views/ams/index')
        }
      ]
    },
    {
      path: '/account',
      component: Layout,
      redirect: '/account/index',
      name: 'Account', //账号管理
      children: [
        {
          path: 'index',
          name: 'AccountIndex',
          component: () => import('@/views/account/index')
        },
        {
          path: 'create',
          name: 'AccountCreate',
          component: () => import('@/views/account/create')
        },
        {
          path: 'detail/:id',
          name: 'AccountDetail',
          component: () => import('@/views/account/detail')
        }
      ]
    },
    {
      path: '/suggest',
      component: Layout,
      redirect: '/suggest/index',
      name: 'Suggest', //意见管理
      children: [
        {
          path: 'index',
          name: 'SuggestIndex',
          component: () => import('@/views/suggest/index')
        }
      ]
    },
    {
      path: '/config',
      component: Layout,
      redirect: '/config/type',
      name: 'Config', //意见管理
      children: [
        {
          path: 'type',
          name: 'Type',
          component: () => import('@/views/config/type/index')
        }
      ]
    },
    {
      path: '/test',
      component: Layout,
      redirect: '/test/index',
      name: 'Test', //数据概览
      children: [
        {
          path: 'index',
          name: 'TestIndex',
          component: () => import('@/views/test/index')
        }
      ]
    },
    {
      path: '/order',
      component: Layout,
      redirect: '/order/page',
      name: 'Order',
      children: [
        {
          path: 'page',
          name: 'OrderPage',
          component: () => import('@/views/order/page')
        },
        {
          path: 'notify',
          name: 'NotifyPage',
          component: () => import('@/views/order/notify')
        }
      ]
    },
    {
      path: '/invoice',
      component: Layout,
      redirect: '/invoice/page',
      name: 'Invoice',
      children: [
        {
          path: 'page',
          name: 'InvoicePage',
          component: () => import('@/views/invoice/page')
        },
        {
          path: 'info',
          name: 'InfoPage',
          component: () => import('@/views/invoice/info')
        },
        {
          path: 'manager',
          name: 'ManagerPage',
          component: () => import('@/views/invoice/manager')
        }
      ]
    },
    {
      path: '/applicationtype',
      component: Layout,
      redirect: '/applicationtype/index',
      name: 'Applicationtype',
      children: [
        {
          path: 'index',
          name: 'Applicationtypeindex',
          component: () => import('@/views/applicationtype/index')
        },
      ]
    },
    //逆变器管理
    {
      path: '/Invertermanagement',
      component: Layout,
      redirect: '/Invertermanagement/index',
      name: 'Invertermanagement',
      children: [
        {
          path: 'index',
          name: 'Invertermanagementindex',
          component: () => import('@/views/Invertermanagement/index')
        },
        {
          path: 'user',
          name: 'Userindex',
          component: () => import('@/views/Invertermanagement/user')
        },
        {
          path: 'Invertermodel',
          name: 'Invertermodelindex',
          component: () => import('@/views/Invertermanagement/Invertermodel')
        },
        {
          path: 'InverterInformation',
          name: 'InverterInformationindex',
          component: () => import('@/views/Invertermanagement/InverterInformation')
        },
      ]
    },
    //固件升级管理
     {
      path: '/FirmwareVersion',
      component: Layout,
      redirect: '/FirmwareVersion/index',
      name: 'FirmwareVersion',
      children: [
        {
          path: 'index',
          name: 'FirmwareVersionindex',
          component: () => import('@/views/FirmwareVersion/index')
        },
        {
          path: 'Remoteupgrade',
          name: 'Remoteupgradeindex',
          component: () => import('@/views/FirmwareVersion/Remoteupgrade')
        },
        // {
        //   path: 'Invertermodel',
        //   name: 'Invertermodelindex',
        //   component: () => import('@/views/Invertermanagement/Invertermodel')
        // },
        // {
        //   path: 'InverterInformation',
        //   name: 'InverterInformationindex',
        //   component: () => import('@/views/Invertermanagement/InverterInformation')
        // },
      ]
    },
    //采集棒平台管理
    {
      path: '/collectionrod',
      component: Layout,
      redirect: '/collectionrod/index',
      name: 'collectionrod',
      children: [
        {
          path: 'index',
          name: 'collectionrodindex',
          component: () => import('@/views/collectionrod/index')
        },
        {
          path: 'detail',
          name: 'detailindex',
          component: () => import('@/views/collectionrod/detail')
        },   
      ]
    },
     //采集棒平台管理
     {
      path: '/devicestatus',
      component: Layout,
      redirect: '/devicestatus/index',
      name: 'devicestatus',
      children: [
        {
          path: 'index',
          name: 'collectionrodindex',
          component: () => import('@/views/devicestatus/index')
        },
        // {
        //   path: 'detail',
        //   name: 'detailindex',
        //   component: () => import('@/views/devicestatus/detail')
        // },   
      ]
    },
    {
      path: '/ai',
      component: Layout,
      redirect: '/ai/index',
      name: 'ai',
      children: [
        {
          path: 'index',
          name: 'aiindex',
          component: () => import('@/views/ai/index')
        },   
      ]
    },
    {
      path: '/broker',
      component: Layout,
      redirect: '/broker/index',
      name: 'broker',
      children: [
        {
          path: 'index',
          name: 'brokerindex',
          component: () => import('@/views/broker/index')
        },
      ]
    },
    {
      path: '/nobroker',
      component: Layout,
      redirect: '/nobroker/index',
      name: 'nobroker',
      children: [
        {
          path: 'index',
          name: 'nobrokerindex',
          component: () => import('@/views/nobroker/index')
        },
      ]
    },
    {
      path: '/devicestatusrun',
      component: Layout,
      redirect: '/devicestatusrun/index',
      name: 'devicestatusrun',
      children: [
        {
          path: 'index',
          name: 'collectionrodindex',
          component: () => import('@/views/devicestatusrun/index')
        }, 
      ]
    },
    {
      path: '/SSHEQM',
      component: Layout,
      redirect: '/SSHEQM/index',
      name: 'SSHEQM',
      children: [
        {
          path: 'index',
          name: 'collectionrodindex',
          component: () => import('@/views/SSHEQM/index')
        }, 
      ]
    },
    {
      path: '/ssllog',
      component: Layout,
      redirect: '/ssllog/index',
      name: 'ssllog',
      children: [
        {
          path: 'index',
          name: 'ssllogindex',
          component: () => import('@/views/ssllog/index')
        }, 
      ]
    },
    {
      path: '/directives',
      component: Layout,
      redirect: '/directives/index',
      name: 'directives',
      children: [
        {
          path: 'index',
          name: 'directivesindex',
          component: () => import('@/views/directives/index')
        }, 
      ]
    },
    
    {
      path: '/deviceabnormal',
      component: Layout,
      redirect: '/deviceabnormal/index',
      name: 'deviceabnormal',
      children: [
        {
          path: 'index',
          name: 'deviceabnormalindex',
          component: () => import('@/views/deviceabnormal/index')
        },
        {
          path: 'operation/id',
          name: 'OperationManager',
          component: () => import('@/views/deviceabnormal/operation')
        },
      ]
    },
    {
      path: '/deviceexception',
      component: Layout,
      redirect: '/deviceexception/index',
      name: 'deviceexception',
      children: [
        {
          path: 'index',
          name: 'deviceexceptionindex',
          component: () => import('@/views/deviceexception/index')
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js